import React, { useState, useEffect } from "react";
import { Row, Col, Dropdown, Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "../css/Nav.css"

const NavBar = () => {
  const [find, setFind] = useState("")
  const navigate = useNavigate();
  const handleOnClick = (page) => () => {
    window.scrollTo(0, 0);
    navigate(`/${page}`);
  };

  const handleSearch = (e) => {
    if (find == "Dallas") {
      e.preventDefault();
      navigate(`/communities`);
    } 
    else if(find == "Allen" ) {
      e.preventDefault();
      navigate(`/communities`);
      
    } 
    else if(find == "Garland" ) {
      e.preventDefault();
      navigate(`/communities`);

    } 
    else if(find == "Frisco" ) {
      e.preventDefault();
      navigate(`/communities`);

    } 
    else if(find == "Richardson" ) {
      e.preventDefault();
      navigate(`/communities`);

    } 
    else if(find == "Fort Worth" ) {
      e.preventDefault();
      navigate(`/communities`);

    } 
    
    else {
        alert("This city is out of our services")
    }}

  return (
    
    <div>
    <Nav defaultActiveKey="/home" className="ul">
      {/* <div class="navbar"> */}
      <div class="logo">
        <button onClick={handleOnClick("home")} style={{background:"transparent", border:"0",cursor: "pointer",}}>
        <img src="templogo.png" height="100" width="100"></img>
        </button>
      </div>
      <input type="text" placeholder="Search for communities" onChange={e => setFind(e.target.value)}></input>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
      <button style={{background:"transparent", color:"white", width:"100%", padding:"20px", borderRadius:"10px"}} onClick={handleSearch}>
            Search
      </button>
      </div>
    <Nav.Item as="li">
      <Nav.Link href="/home" onClick={handleOnClick("home")}>Home</Nav.Link>
    </Nav.Item>
    <Nav.Item as="li">
      <Nav.Link eventKey="link-1" onClick={handleOnClick("communities")}>Communities</Nav.Link>
    </Nav.Item>
    <Nav.Item as="li">
      <Nav.Link eventKey="link-2" onClick={handleOnClick("events")}>Events</Nav.Link>
    </Nav.Item>
    <Nav.Item as="li">
      <Nav.Link eventKey="link-3" onClick={handleOnClick("about")}>About Us</Nav.Link>
    </Nav.Item>
    {/* </div> */}
  </Nav>
  </div>
  );
};

export default NavBar;
